import {Pipe, PipeTransform} from '@angular/core';
import {Util} from '../models/generico/util';

@Pipe({
    name: 'kDate'
})
export class KDatePipe implements PipeTransform {

    transform(value?: Date | string): string {
        const date = Util.parseDate(value);
        if (!date) {
            return '';
        }
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${this.padZero(day)}/${this.padZero(month)}/${year} ${this.padZero(hours)}:${this.padZero(minutes)}`;
    }

    private padZero(num: number): string {
        return num.toString().padStart(2, '0');
    }
}
